import AdditionVisual from "../../components/ClassTwo/NumberMath/AdditionVisual";
import AdditionWord from "../../components/ClassTwo/NumberMath/AdditionWord";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/addition/visual-problem", title: "Visual Problem", component: AdditionVisual },
    { url: "/class-two/number-math/addition/word-problem", title: "Word Problem", component: AdditionWord }
];

export default topics;